import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HistoryComponent} from './history/history.component';
import {PrinciplesComponent} from './principles/principles.component';
import {TeamComponent} from './team/team.component';
import {TranslateModule} from '../../shared/pipes/translate/translate.module';
import {TeamInfoComponent} from './team/team-info/team-info.component';
import {TeamUserComponent} from './team/team-user/team-user.component';

@NgModule({
  declarations: [
    HistoryComponent,
    PrinciplesComponent,
    TeamComponent,
    TeamInfoComponent,
    TeamUserComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [
    HistoryComponent,
    PrinciplesComponent,
    TeamComponent
  ]
})
export class AboutModule {
}
